//import Swiper from "swiper";
import $ from "jquery"
import VanillaTilt from "vanilla-tilt";
//let swiper = new Swiper(".swiper", {
//    speed: 400,
//    spaceBetween: 100,
//});


const defOptions = {
    reverse: false,
    max: 15,
    startX: 0,
    startY: 0,
    perspective: 1e3,
    easing: "cubic-bezier(.03,.98,.52,.99)",
    scale: 1,
    speed: 300,
    transition: true,
    axis: null,
    glare: false,
    "max-glare": 1,
    "glare-prerender": false,
    "full-page-listening": false,
    "mouse-event-element": null,
    reset: true,
    gyroscope: true,
    gyroscopeMinAngleX: -45,
    gyroscopeMaxAngleX: 45,
    gyroscopeMinAngleY: -45,
    gyroscopeMaxAngleY: 45,
    gyroscopeSamples: 10
};
const PLUGIN_DATA_KEY = "bidiao:vanilla-tilt";
interface JQueryVanillaTilt extends JQuery {

}

declare global {
    interface JQuery {
        VanillaTilt(): JQueryVanillaTilt;
        VanillaTilt(this: JQuery, options?: Partial<typeof defOptions>): JQueryVanillaTilt;
    }
    interface HTMLElement {
        plugins: Record<string, any>
    }
}

function CreateVanillaTilt(this: JQuery, options: Partial<typeof defOptions> = {}): JQueryVanillaTilt {
    return this.each((index, elm) => {
        elm.plugins = elm.plugins || {};
        const instance = elm.plugins[PLUGIN_DATA_KEY];
        if (!instance) {
            VanillaTilt.init(elm, $.extend({}, defOptions, options));
            elm.plugins[PLUGIN_DATA_KEY] = true;
        }
    })
}

$.fn.extend({ VanillaTilt: CreateVanillaTilt });


//$("[data-tilt]").VanillaTilt();
